//#region eMenuItems

export enum eMenuItems {
  communication_messaging                           =    0,
  communication_config                              =    1,
      
  companies                                         =   10,
  companies_component_access                        =   11,
  companies_dropdown                                =   12,
  companies_hierachy                                =   13,
  companies_portal_access                           =   14,
      
  configuration_account_managers                    =  100,
  configuration_components                          =  101,
  configuration_components_containers               =  102,
  configuration_components_dropdown                 =  103,
  configuration_country_groups                      =  104,
  configuration_dropdown                            =  105,
  configuration_licences_company_allocated          =  106,
  configuration_licences_company_visible            =  107,
  configuration_licences_dropdown                   =  108,
  configuration_licences_system                     =  109,
  configuration_mapping                             =  110,
  configuration_mapping_addresses                   =  111,
  configuration_mapping_countries                   =  112,
  configuration_mapping_mapped_countries            =  113,
  configuration_mapping_mapped_zones                =  114,
  configuration_mapping_world_maps                  =  115,
  configuration_mapping_world_zones                 =  116,
  configuration_mdm_devices                         =  117,
  configuration_partner_links                       =  118,
  configuration_products                            =  119,
  configuration_reports                             =  120,
  configuration_screen_defaults                     =  121,
  configuration_screen_defaults_base                =  122,
  configuration_screen_defaults_company             =  123,
  configuration_screen_defaults_company_actual      =  124,
  configuration_screen_defaults_user                =  125,
  configuration_screen_defaults_user_actual         =  126,
  configuration_system                              =  127,
  configuration_types                               =  128,
  configuration_types_access                        =  129,
  configuration_types_audit                         =  130,
  configuration_types_billing_service               =  131,
  configuration_types_brand                         =  132,
  configuration_types_charge                        =  133,
  configuration_types_communication                 =  134,
  configuration_types_communication_delivery_status =  135,
  configuration_types_company                       =  136,
  configuration_types_company_file                  =  137,
  configuration_types_currency                      =  138,
  configuration_types_currency_symbol               =  139,
  configuration_types_data_weight                   =  140,
  configuration_types_delivery                      =  141,
  configuration_types_device                        =  142,
  configuration_types_download_file                 =  143,
  configuration_types_language                      =  144,
  configuration_types_licence                       =  145,
  configuration_types_manufacturer                  =  146,
  configuration_types_mdm_compliance_issue          =  147,
  configuration_types_mdm_device                    =  148,
  configuration_types_mdm_device_eol_source         =  149,
  configuration_types_mdm_device_eos_source         =  150,
  configuration_types_mdm_status                    =  151,
  configuration_types_message                       =  152,
  configuration_types_occupation                    =  153,
  configuration_types_order_status                  =  154,
  configuration_types_payment_method                =  155,
  configuration_types_payment_term                  =  156,
  configuration_types_portal                        =  157,
  configuration_types_recurring                     =  158,
  configuration_types_rounding                      =  159,
  configuration_types_support_plan                  =  160,
  configuration_types_tariff                        =  161,
  configuration_types_tariff_band_level             =  162,
  configuration_types_ticket_issue                  =  163,
  configuration_types_ticket_priority               =  164,
  configuration_types_user_link                     =  165,
  configuration_types_webhook                       =  166,

  dashboard_analytics                               =  200,
  dashboard_crm                                     =  201,
  dashboard_crypto                                  =  202,
  dashboard_dropdown                                =  203,
  dashboard_ecommerce                               =  204,
  dashboard_job                                     =  205,
  dashboard_nft                                     =  206,
  dashboard_projects                                =  207,
  dashboard_usage                                   =  208,
     
  demo_cost_and_usage_reports                       =  300,
  demo_dashboard                                    =  301,
  demo_dropdown                                     =  302,
  demo_live_view                                    =  303,
  demo_manage_change_spend_limit                    =  304,
  demo_manage_change_tariff_plan                    =  305,
  demo_sim_management                               =  306,
  demo_user_management                              =  307,
     
  inventory                                         =  350,

  invoicing_dropdown                                =  400,
     
  links_dropdown                                    =  500,
  links_nperf                                       =  501,
  links_nperf_map_5g                                =  502,
  links_nperf_map_coverage                          =  503,
  links_nperf_map_speed                             =  504,
     
  location_services                                 =  525,

  mdm_compliance_campaigns                          =  550,
  mdm_device_compliance                             =  551,
  mdm_device_compliance_logs                        =  552,
  mdm_device_notification_logs                      =  553,
  mdm_device_remediation                            =  554,
  mdm_devices_company                               =  555,
  mdm_devices_company_config                        =  556,
  mdm_devices_company_settings                      =  557,
  mdm_devices_templates_compliance_campaigns        =  558,
  mdm_devices_templates_remediation                 =  559,
  mdm_devices_templates_remediation_to_status       =  560,
  mdm_intune_dashboard                              =  561,
  mdm_intune_devices                                =  562,
  mdm_intune_dropdown                               =  563,
  mdm_intune_sim_exceptions                         =  564,
  mdm_intune_users                                  =  565,
  mdm_logs                                          =  566,
     
  provisioning_devices_allocated                    =  600,
  provisioning_devices_available                    =  601,
  provisioning_devices_dropdown                     =  602,
  provisioning_orders                               =  603,
  provisioning_orders_dropdown                      =  604,
  provisioning_orders_historic                      =  605,
  provisioning_provision_esim                       =  606,
  provisioning_provision_esim_bulk                  =  607,
     
  reporting_financial                               =  700,
  reporting_financial_dropdown                      =  701,

  risk_intelligence_advisories                      =  750,
  risk_intelligence_alerts                          =  751,
  risk_intelligence_city_reports                    =  752,
  risk_intelligence_country_risk_levels             =  753,
  risk_intelligence_dropdown                        =  754,
  risk_intelligence_local_risk_levels               =  755,
  risk_intelligence_travel_risk_management          =  756,
  risk_intelligence_travel_search                   =  757,
  risk_intelligence_trip_ready                      =  758,
  risk_intelligence_usage_report                    =  759,
  risk_intelligence_user_entitlements               =  760,

  signals_breach_exposure                           =  770,
  signals_corporate_health                          =  771,
  signals_dashboard                                 =  772,
  signals_device_vulnerabilities                    =  773,
  signals_dropdown                                  =  774,
  signals_travel_risk_advisories                    =  775,
  signals_travel_risk_alerts                        =  776,
  signals_travel_risk_city_report                   =  777,
  signals_travel_risk_comparison                    =  778,
  signals_travel_risk_country_levels                =  779,
  signals_travel_risk_country_report                =  780,
  signals_travel_risk_dropdown                      =  781,
  signals_travel_risk_exposure                      =  782,
  signals_travel_risk_trip_brief                    =  783,

  suppliers                                         =  800,
  suppliers_dropdown                                =  801,
     
  support_dropdown                                  =  900,
  support_help                                      =  901,
  support_page                                      =  902,
  support_ticket_hub                                =  903,
     
  system_admin_api_management                       = 1000,
  system_admin_audit                                = 1001,
  system_admin_audit_dropdown                       = 1002,
  system_admin_audit_sms                            = 1003,
  system_admin_credit_limit_alert_recipients        = 1004,
  system_admin_credit_limit_management              = 1005,
  system_admin_credit_limits                        = 1006,
  system_admin_dropdown                             = 1007,
  system_admin_overview                             = 1008,
  system_admin_platform_insights                    = 1009,
  system_admin_system_locks                         = 1010,
  system_admin_teams                                = 1011,
  system_admin_teams_calls                          = 1012,
  system_admin_teams_statuses                       = 1013,
  system_admin_transfer_user_sim                    = 1014,
  system_admin_triggered_alerts                     = 1015,
  system_admin_unresolved_mobile                    = 1016,
  system_admin_user_browser_info                    = 1017,
  system_admin_user_client_info                     = 1018,
  system_admin_user_dropdown                        = 1019,
  system_admin_user_sessions                        = 1020,

  tariffs_dropdown                                  = 1100,
  tariffs_rental                                    = 1101,
  tariffs_rental_tariff_bands                       = 1102,
  tariffs_rental_tariffs                            = 1103,
  tariffs_rental_tariffs_details                    = 1104,
  tariffs_usage                                     = 1105,
  tariffs_usage_scheme_rates                        = 1106,
  tariffs_usage_schemes                             = 1107,
  tariffs_usage_tariff_zones                        = 1108,
  tariffs_usage_tariffs                             = 1109,
     
  timeline_                                         = 1203,
     
  title_billing                                     = 1300,
  title_communication                               = 1301,
  title_home                                        = 1302,
  title_mdm                                         = 1303,
  title_menu                                        = 1304,
  title_organisation                                = 1305,
  title_provisioning                                = 1306,
  title_reporting                                   = 1307,
  title_risk_intelligence                           = 1308,
  title_settings                                    = 1309,
  title_support                                     = 1310,
  title_tariffs                                     = 1311,
     
  users_add                                         = 1400,
  users_component_access                            = 1401,
  users_dropdown                                    = 1402,
  users_associate                                   = 1403,
  users_esim                                        = 1404,
  users_portal                                      = 1405,
}

//#endregion

//#region Riskline

export enum eRisklineCarrierType {
  Aviation       ='aviation',
  Ground         ='ground',
  Maritime       ='maritime',
  PublicTransport='public transport',
  Rail           ='rail',
}

export enum eRisklineCategory {
  PoliticalDevelopments     =1,
  ConflictAndTerrorism      =2,
  DemonstrationAndUnrest    =3,
  Crime                     =4,
  NaturalAndEnvironmental   =5,
  HealthAndMedical          =6,
  TravelSafetyAndDisruptions=7,
}

export enum eRisklineImpactType {
  ForAll       ='for_all',
  ForTravellers='for_travellers',
}

export enum eRisklineRiskLevel {
  Low     =1,
  Moderate=2,
  Medium  =3,
  High    =4,
  Extreme =5,
}

export enum eRisklineTakesPlace {
  Future='future',
  Now   ='now',
  Past  ='past',
}

export enum eRisklineTravellerAssessmentLevel {
  NormalConcern  =1,
  ElevatedConcern=2,
  HighConcern    =3,
}

//#endregion

//#region Signals (OSINT)

export enum eCorporateFilingStatus {
  UpToDate       =1,
  DueSoon        =2,
  Overdue        =3,
  StrikeOffNotice=4,
  Insolvent      =5,
  Dissolved      =6,
}

export enum eSignalCategory {
  CorporateHealth     =1,
  BreachExposure      =2,
  DeviceVulnerability =3,
  GeopoliticalExposure=4,
  TravelRisk          =5,
}

export enum eSignalSeverity {
  Informational=1,
  Low          =2,
  Medium       =3,
  High         =4,
  Critical     =5,
}

export enum eSignalSource {
  CompaniesHouse        =1,
  TheGazette            =2,
  VatValidation         =3,
  WhoIs                 =4,
  HaveIBeenPwned        =5,
  NationalVulnDb        =6,
  FcdoTravelAdvice      =7,
  Gdacs                 =8,
  UsStateDepartment     =9,
  DfatAustralia         =10,
  WorldHealthOrg        =11,
  Ecdc                  =12,
  Notam                 =13,
  ClaudeSynthesis       =14,
  TravelAdvisoryChanges =15,
  GovernmentTravelAlerts=16,
}

export enum eSignalStatus {
  New         =1,
  Acknowledged=2,
  Investigating=3,
  Resolved    =4,
  Dismissed   =5,
}

export enum eTravelRiskDerivation {
  HighestOfSources=1,
  WeightedAverage =2,
  LlmSynthesised  =3,
  ManualOverride  =4,
}

//#endregion

//#region Travel Risk

export enum eTravelRiskDataProvider {
  Riskline=1,
  SureSIM =2,
}

//#endregion

//#region Types

export enum AlertType {
  Cost     ='Cost',
  Data     ='Data Used (MB)',
  CostLimit='% of Limit',
}

export enum CreditLimitActionsCompany {
  Nothing        =0,
  Suspend        =1,
  Throttle512Kbps=2,
}

export enum eDatePrecision {
  DayMonthYear="dd/mm/yyyy",
  MonthYear   ="mm/yyyy",
  Year        ="yyyy",
}

export enum DeliveryType {
  Email       =1,
  Notification=2,
  SMS         =3,
  InApp       =4,
}

export enum DeviceActivationType {
  PushViaEID     =1,
  SendViaSMSEmail=2, //RBW_20260604 - Legacy: device OS decides SMS vs email (still used in single-SIM provisioning). Bulk uses the explicit values below.
  SendViaSMS     =3,
  SendViaEmail   =4,
  SendViaManual  =5,
  PushViaICCID   =6,
}

export enum DeviceOSType {
  AppleIOS=1,
  Android =2,
  Windows =3,
}

export enum eDeviceType {
  unknown=0,
  esim   =1,
  sim    =2,
}

export enum MessageType {
  Welcome                     = 1,
  WelcomeHome                 = 2,
  CountryChangeUseSim         = 3,
  CountryChangeDontUseSim     = 4,
  Alert                       = 5,
  SimsNeedingCeasing          = 6,
  ImeiLockBreach              = 7,
  ProvisioningViaSMS          = 8,
  ProvisioningViaEmail        = 9,
  MdmDeviceRemediation        =10,
  MdmDeviceComplianceCampaign =11,
  CommunicationComposeTemplate=13,
  ProvisioningViaManual       =14,
  LocationConsentRequest      =15,
}

export enum MessageTypeText {
  Alert                       ="Alert",
  CommunicationComposeTemplate="Communication Compose Template",
  CountryChangeUseSim         ="Country Change Use Sim",
  CountryChangeDontUseSim     ="Country Change Don't Use Sim",
  MdmDeviceComplianceCampaign ="Mdm Device Compliance Campaign",
  MdmDeviceRemediation        ="Mdm Device Remediation",
  Welcome                     ="Welcome",
  WelcomeHome                 ="Welcome Home",
}

export enum SmsProviderOverride {
  Default=0,
  SureSim=1,
  Twilio =2,
  Both   =3, //CRN_20260819 - SureSIM & Twilio
}

export enum StatementScope {
  CompanyOnly=1,
  Hierarchy  =2,
}

export enum ThrottleType {
  Throttle64k =1,
  Throttle512k=2,
}

//#endregion

//#region Webhook

export enum eWebhookLogTriggerSource {
  Unknown=0,
  Live   =1,
  Replay =2,
  Test   =3,
}

//#endregion

//#region xStd enums

export enum DateRange {
  Day  =1,
  Month=2,
  Year =3,
}

export enum EspReports
{
    Unknown                                   = 0,
    UsageCostPerSimFullMonth                  = 1,
    UsageCostCountryPerSimFullMonth           = 2,
    UsageCostCountryCarrierPerUserFullMonth   = 3,
    CountrySummary                            = 4,
    CarrierSummary                            = 5,
    ApplicationSummary                        = 6,
    UsageCostPerCompanyFullMonth              = 7,
    UsageCostCountryPerCompanyFullMonth       = 8,
    UsageCostCountryCarrierPerCompanyFullMonth= 9,
    UsageCostPerSimDaily                      =10,
    UsageCostPerCompanyDaily                  =11,
    UsageCostCountryPerSimDaily               =12,
    UsageCostCountryPerCompanyDaily           =13,
    UsageCostCountryCarrierPerUserDaily       =14,
    UsageCostCountryCarrierPerCompanyDaily    =15,
    UsageApplicationPerSimFullMonth           =16,
    UsageApplicationPerSimDaily               =17,
    UsageApplicationCompanyFullMonth          =18,
    UsageApplicationCompanyDaily              =19,
    UsageEvery30Minutes                       =20,
    CostSummary                               =21,
    AuditSummary                              =22,
    CostSummaryByCompany                      =23,
};

export enum EspSystemEntities
{
    Unknown      = 0,
    Company      = 1,
    User         = 2,
    Product      = 3,
    Order        = 4,
    ImeiIccid    = 5,
    Alert        = 6,
    Device       = 7,
    InviewCompany= 8,
    InviewUser   = 9,
    LoggedInUser =10,
    ReportType   =11,
};

export enum EspTypeSupportPlan {
  Unknown   =0,
  Business  =1,
  Enterprise=2,
}

export enum eUser {
  unknown  =0,
  associate=1,
  sim      =2,
  portal   =3,

}

export enum LimitType {
  Off  =1,
  Spend=2,
  Data =3,
}

export enum LimitTypeName {
  Off  ="Off",
  Spend="Spend",
  Data ="Data",
}

export enum LinkExpiryPeriodType {
  Days   = 1,
  Weeks  = 2,
  Months = 3
}

//RBW_20260922 - Mirrors PublicEnums.LocationAwarenessStatus on the API. Location awareness is only actually
//               provided at On; AwaitingConfirmation means the user has been sent their one-time opt-in link.
export enum LocationAwarenessStatus {
  Unknown             =0,
  Off                 =1,
  AwaitingConfirmation=2,
  On                  =3,
}

export enum LocationServicesZoomLevel {
  Unknown=0,
  World  =1,
  Country=2,
  User   =3,
}

export enum MessageDefaultDeliveryTypes {
  SMS   = 1,
  Email = 2,
  Both  = 3
}

export enum TemplateModalAction {
  Cancel       =1,
  Save         =2,
  SaveAndEnable=3,
}

//#endregion
